import React from "react";
import { AppShell } from "../components/layout/AppShell";
import { useAuth } from "../context/AuthContext";
import { ThemeToggle } from "../components/ThemeToggle";
import { useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";

export default function Account() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <AppShell>
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-10 md:py-14">
        <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
          Account
        </div>
        <h1 className="font-heading text-3xl md:text-5xl font-bold tracking-tighter mt-1">
          Your profile
        </h1>

        <div className="mt-8 bg-card border border-border/60 rounded-[24px] p-6 md:p-8 shadow-subtle space-y-5">
          <Row label="Name" value={user?.name} />
          <Row label="Email" value={user?.email} />
          <Row
            label="Role"
            value={
              <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-bold">
                {(user?.role === "admin" || user?.role === "master_admin") && <ShieldCheck size={13} strokeWidth={1.8} />}
                {user?.role === "master_admin" ? "master admin" : user?.role}
              </span>
            }
          />
        </div>

        <div className="mt-8 flex items-center gap-3">
          <ThemeToggle />
          <button
            data-testid="account-logout"
            onClick={() => {
              logout();
              navigate("/login");
            }}
            className="h-11 px-5 rounded-full border border-border/60 inline-flex items-center gap-2 text-sm hover:bg-secondary transition"
          >
            <LogOut size={14} /> Logout
          </button>
        </div>
      </div>
    </AppShell>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between gap-4 border-b border-border/60 pb-4 last:border-0 last:pb-0">
      <span className="text-xs uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <span className="font-medium">{value}</span>
    </div>
  );
}
